<template>
	<div class="order-note bg-white pay-success" v-show="loaded">
		<div class="success" v-if="!oldUser">
			<img src="/static/img/payicon.png">
				<div class="tip">{{ tips }}</div>
		</div>
		<div class="row">
			<div class="actions">
				<p style="margin-top: 5px;padding:0 50px;" v-text="messageTitle" v-if="!oldUser"></p>
				<div class="qr-image" v-show="completed" v-if="!oldUser">
					<img style="width:250px;" :src="qrsrc">
				</div>

				<div class="old-user user-img" v-if="oldUser">
					<img :src="avatar">
				</div>
				<div class="old-user user-name text" v-if="oldUser">
					<div>恭喜您，服务已开通</div>
					<div>请在此头像对应的微信号{{ username }}内查看</div>
				</div>
				<img class="old-user user-bg" src="/static/img/done_head_bg.png" v-if="oldUser">
				<p style="margin: 10px 0; padding: 0 60px; font-size:13px;" v-show="completed">
					{{ bottomTips }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: "OrderPurchaseDone",
	data: () => ({
		tips: "恭喜您，服务开通中...",
		messageTitle: "",
		loaded: false,
		completed: false,
		qrsrc: null,
		bottomTips: "温馨提示：如果关注后看不到内容，请等候片刻，便可正常使用",
		oldUser: false,
		username: "",
		avatar: "/static/img/user.png"
	}),
	computed: {
		...mapGetters({
			qyh: "getQyh"
		})
	},
	created() {
		this.fetchDetail()
	},
	components: {},
	mounted: function() {
		this.setPageTitle("服务开通")
		this.qrsrc = "/static/img/" + this.qyh.qr
	},
	methods: {
		handleError (response) {
			this.loaded = true
			this.tips = response.body.message
			this.messageTitle = "如有疑问请联系您的专属服务助理"
			this.handleHttpError(response)
		},
		handleTransVerify (response) {
			this.setPageTitle("财务查账核实")
			this.tips = "我司财务正在核实您的查账信息"
			this.messageTitle = "请耐心等候我司财务核实查账信息，您的专属服务助理会联系您签订合同，如有疑问请联系专属服务助理"
			this.completed = false
		},
		handleSuccess (rs) {
			this.setPageTitle("服务开通")
			this.saveLog()
			if (rs.data.name === false && rs.data.avatar === false) {
				if (this.isInWeixin()) {
					if (this.isPC()) {
						this.messageTitle = "扫描二维码，关注进入企业号"
					} else {
						this.messageTitle = "长按识别二维码，关注进入企业号"
					}
				} else if (this.isMobile()) {
					this.messageTitle = "请保存二维码后，在微信内长按识别二维码，关注进入企业号"
				} else {
					this.messageTitle = "扫描二维码，关注进入企业号"
				}
			} else {
				this.oldUser = true
				this.username = rs.data.name
				this.avatar = rs.data.avatar
				this.bottomTips = "如有疑问，请联系您的专属助理"
			}
			this.completed = true
		},
		handleOnGoing (rs) {
			this.setPageTitle("合同签订完成")
			this.tips = "服务开通中"
			this.messageTitle = "如有疑问请联系您的专属服务助理"
		},
		fetchDetail() {
			let url = "/api/contracts/open/" + this.$route.params.id
			this.$http.post(url).then(
				response => {
					var rs = response.body
					if (rs.code > 0) {
						this.handleError(response)
						return
					}
					if (rs.data.is_qy_service === 0) {
						window.location.href = "#/noservice/order/done"
					}
					if (rs.data.order_status === 33) {
						this.handleTransVerify(response)
					} else if (rs.data.opened === true) {
						this.handleSuccess(rs)
					} else {
						this.handleOnGoing(rs)
					}
					this.loaded = true
				},
				response => {
					this.handleHttpError(response)
				}
			)
		},
		saveLog() {
			let url = "/api/orders/contracts/complete"
			this.$http.put(url).then(response => {}, response => {})
		}
	}
}
</script>

<style scoped>
.old-user {
	position: relative;
	width: 100%;
	max-width: 500px;
	margin: auto;
	margin-top: 160px;
}
.old-user.user-img {
	position: absolute;
	width: 18%;
	left: 41%;
	top: 16%;
	overflow: hidden;
	border-radius: 50%;
	z-index: 66;
}
.old-user.user-img img {
	width: 100%;
}

.old-user.user-bg {
	position: relative;
	width: 100%;
	z-index: 55;
}
.old-user.user-name {
	position: absolute;
	top: 48%;
	width: 100%;
	color: #fff;
	font-family: "宋体";
	font-weight: 700;
	text-align: center;
	z-index: 66;
}
.old-user.user-name div:nth-child(1) {
	font-size: 20px;
}
.old-user.user-name div:nth-child(2) {
	font-size: 16px;
	margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// OrderPurchaseDone.vue?68fb0372